import { useKeycloak } from "@react-keycloak/web";
import axios, { CanceledError } from "axios";
import { toast } from "react-toastify";
import { API_VERSION, BACK_END_URL } from "../api";

function useMyApiClient() {
  const { keycloak } = useKeycloak();

  const instance = axios.create({
    baseURL: `${BACK_END_URL}/${API_VERSION}`,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
      Pragma: "no-cache",
    },
  });

  // Request interceptor: attach the latest token on every request
  instance.interceptors.request.use((config) => {
    if (keycloak.token) {
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  });

  // Response interceptor: on 401 refresh the token and retry once
  instance.interceptors.response.use(
    (response) => response ?? { data: {} },
    async (error) => {
      if (error instanceof CanceledError) {
        return {};
      }

      const originalRequest = error.config;

      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          await keycloak.updateToken(5);
          originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
          return instance(originalRequest);
        } catch {
          toast.error("Session expired. Please login again.");
          keycloak.logout({ redirectUri: window.location.origin });
          return Promise.reject(error);
        }
      }

      return Promise.reject(error);
    }
  );

  return instance;
}

export default useMyApiClient;
export { CanceledError };
